define("shared/components/shared/page-picker", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/utils", "@glimmer/component", "@latermedia/ember-later-analytics/utils/state-types"], function (_exports, _component, _templateFactory, _object, _utils, _component2, _stateTypes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@latermedia/ember-later-analytics/utils/state-types"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{!TODO update spans to buttons for a11y}}
  <div class="o--btnBar u--text--center">
    <span
      aria-label="display previous page"
      class="{{if this.isDecreaseDisabled 'o--btn--disabled'}} o--btn o--btn--c o--btn--mute"
      data-test-id="decrease-page"
      role="button"
      {{! template-lint-disable no-bare-strings }}
      {{on "click" this.decreaseCurrentPageNumber}}
    >
      {{svg-jar "nav-left" class="o--icon"}}
    </span>
    <span class="o--btnGroup">
      <span class="u--p__sm u--text--bold">{{@currentPageNumber}}</span>
    </span>
    <span
      aria-label="display next page"
      class="{{if this.isIncreaseDisabled 'o--btn--disabled'}} o--btn o--btn--c o--btn--mute"
      data-test-id="increase-page"
      role="button"
      {{! template-lint-disable no-bare-strings }}
      {{on "click" this.increaseCurrentPageNumber}}
    >
      {{svg-jar "nav-right" class="o--icon"}}
    </span>
  </div>
  */
  {
    "id": "CVUQDHkh",
    "block": "[[[10,0],[14,0,\"o--btnBar u--text--center\"],[12],[1,\"\\n  \"],[11,1],[24,\"aria-label\",\"display previous page\"],[16,0,[29,[[52,[30,0,[\"isDecreaseDisabled\"]],\"o--btn--disabled\"],\" o--btn o--btn--c o--btn--mute\"]]],[24,\"data-test-id\",\"decrease-page\"],[24,\"role\",\"button\"],[4,[38,1],[\"click\",[30,0,[\"decreaseCurrentPageNumber\"]]],null],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"nav-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,1],[14,0,\"o--btnGroup\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--p__sm u--text--bold\"],[12],[1,[30,1]],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[11,1],[24,\"aria-label\",\"display next page\"],[16,0,[29,[[52,[30,0,[\"isIncreaseDisabled\"]],\"o--btn--disabled\"],\" o--btn o--btn--c o--btn--mute\"]]],[24,\"data-test-id\",\"increase-page\"],[24,\"role\",\"button\"],[4,[38,1],[\"click\",[30,0,[\"increaseCurrentPageNumber\"]]],null],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"nav-right\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@currentPageNumber\"],false,[\"if\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/page-picker.hbs",
    "isStrictMode": false
  });

  let PagePickerComponent = (_class = class PagePickerComponent extends _component2.default {
    get isLoading() {
      return this.args.state.type === _stateTypes.LOADING;
    }

    get isDecreaseDisabled() {
      return (0, _utils.isEmpty)(this.args.cursors?.previous) || this.isLoading;
    }

    get isIncreaseDisabled() {
      return (0, _utils.isEmpty)(this.args.cursors?.next) || this.isLoading;
    }

    decreaseCurrentPageNumber() {
      if (!this.isDecreaseDisabled && this.args.cursors?.previous) {
        this.args.setCurrentPageNumber(this.args.currentPageNumber - 1);
        this.args.setSelectedCursor(this.args.cursors.previous);
      }
    }

    increaseCurrentPageNumber() {
      if (!this.isIncreaseDisabled && this.args.cursors?.next) {
        this.args.setCurrentPageNumber(this.args.currentPageNumber + 1);
        this.args.setSelectedCursor(this.args.cursors.next);
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "decreaseCurrentPageNumber", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "decreaseCurrentPageNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "increaseCurrentPageNumber", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "increaseCurrentPageNumber"), _class.prototype)), _class);
  _exports.default = PagePickerComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PagePickerComponent);
});